import React, { Component } from 'react'
import { Button, Spin } from 'antd';
import { Link } from 'dva/router'
import { connect } from 'dva'
import moment from 'moment'
import { all, get } from '../../services/restApi'
import { getTotal, getExcerpt } from '../../utils'
import config from '../../utils/config'
import Currency from 'react-currency-formatter';
var Icon = require('react-fontawesome');
const _ = require('underscore');

class Tour extends Component {

    constructor (props) {
        super(props);

        this.state = {
            category: {},
        	activities: []
        };
    }


    /**
    * Inicialización
    */
    componentDidMount () {
        console.log(this.props);

        this.props.dispatch({type: 'app/showLoadingTable'})

        get('Category', this.props.location.query.tour).then((resp) => {

            this.setState({ category: resp });
            this.getActivities();
        })
    }


    /**
    * Obtiene los tours
    */
    getActivities () {
    	all('Activity', {
            where: {
                active: true,
                category: {__type: 'Pointer', className: 'Category', objectId: this.props.location.query.tour}
            },
            include: 'category',
            limit: 1000
        }).then((resp) => {
            this.props.dispatch({type: 'app/hideLoadingTable'})

            this.setState({ activities: resp.results });
        })
    }



    /**
    * Formulario
    */
    handleSubmit (e) {
    	e.preventDefault();
    }


    /**
    * Render del componente
    */
    render () {
        return (
            <div className="row">
                <Spin spinning={this.props.app.loadingTable}>
                    <div className="col-md-12">
                        <div className="tour-cover marginBottom20">
                            <img 
                                alt={this.state.category.name}
                                title={this.state.category.name}
                                src={
                                    this.state.category.picture 
                                        ? config.externalUrl + 'uploads/activities/' + this.state.category.picture 
                                        : 'https://via.placeholder.com/800/09f/fff?text=' + (this.state.category.name ? this.state.category.name : 'Tour')
                                } 
                            />
                        </div>

                        <div className="tour-content">
                            <h2 className="marginBottom10">{this.state.category.name}</h2>
                            <p>{this.state.category.description}</p>

                            {this.state.activities.length > 0
                                ? <h4 className="marginTop30">Actividades</h4>
                                : ''
                            }
                            <ul className="list-activities">
                                {this.state.activities.map((activity) => (
                                    <li>
                                        <strong>{activity.name}</strong> <Currency quantity={activity.price ? activity.price : 0} currency="USD" className="price" /><br />
                                        {activity.description}
                                    </li>
                                ))}
                            </ul>

                            <Button type="primary" className="marginTop20">
                                <Link to="" query={{widget: this.props.location.query.widget, book: this.props.location.query.tour}}><Icon name="book" /> Reservar</Link>
                            </Button>
                        </div>
                    </div>
                </Spin>
            </div>
        )
    }
}

export default connect(({app}) => ({app}))(Tour)


// WEBPACK FOOTER //
// ./src/components/widget/tour.js